import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/welcome.css";   // 👈 IMPORTANT FIX

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/LandingPage");
    }, 2000); // 2 sec splash

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="welcome-container">
      <h1 className="welcome-title">Bhopal Seat Cover</h1>
      <p className="welcome-subtitle">Admin Panel</p>

      <div className="welcome-loader"></div>
    </div>
  );
};

export default Welcome;
